import { SharedModule } from '@shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    AdminGlossaryCreateComponent,
    AdminGlossaryEditComponent,
    AdminGlossaryInfoComponent,
    AdminGlossaryItemComponent
} from '@app/main/admin/modules/admin-glossary/components';
import { AdminGlossaryComponent } from '@app/main/admin/modules/admin-glossary/admin-glossary.component';

@NgModule({
    declarations: [
        AdminGlossaryComponent,
        AdminGlossaryCreateComponent,
        AdminGlossaryEditComponent,
        AdminGlossaryInfoComponent,
        AdminGlossaryItemComponent
    ],
    exports: [AdminGlossaryComponent],
    imports: [CommonModule, SharedModule]
})
export class AdminGlossaryModule {}
